import React from 'react'

import { FilterSortOption, FilterSort } from '@/components/pages/production/components/context/types'

import FilterSheetChip from '../filter-sheet-chip'

import styles from './styles.module.scss'

type FiltersSortChipsProps = {
    activeFilter: FilterSort
    options: FilterSortOption[]
    onClick: (value: FilterSort) => void
}

const FiltersSortChips = ({ options, activeFilter, onClick }: FiltersSortChipsProps) => {
    return (
        <div className={styles.typeChipContainer}>
            <div className={styles.typeChipRow}>
                {options.map((option, index) => (
                    <FilterSheetChip
                        key={index}
                        label={option.label}
                        variant={option.value === activeFilter ? 'filled' : 'outlined'}
                        onClick={() => onClick(option.value)}
                        data-testid={`filter-sort-${option.value}`}
                    />
                ))}
            </div>
        </div>
    )
}

export default FiltersSortChips
